module.exports = "<app-navbar></app-navbar>\n<div class=\"body-content\">\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main